import { Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import GlobalLogoutLoader from "./components/GlobalLogoutLoader";
import { THEME_COLOR } from "./config/club";
export default function ProtectedRoute({ children, role }) {
  const { user, loading, isLoggingOut } = useAuth();

  if (loading) return <div className="position-fixed top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex align-items-center justify-content-center" style={{ zIndex: 9999 }}>
            <div className="spinner-border" style={{ color: THEME_COLOR }} />
          </div>;

  if (isLoggingOut) {
    return <GlobalLogoutLoader />;
  }
  if (!user) return <Navigate to="/join" />;
  if (role && user.role !== role) return <Navigate to="/" />;

  return children;
}
